export enum PRODUCT_TYPE_ENUMS {
  simple = 'simple',
  configurable = 'configurable',
}

export enum PRODUCT_OPTIONS_ENUMS {
  gift = 'is_gift_product',
  giftMessage = 'gift_message',
  greetingCard = 'is_greeting_card',
}

export enum ENTITY_TYPE_ENUMS {
  GIFT_HAMPERS = 'gift hampers',
  RAMZAN_GIFTING = 'ramzan gifting',
}
